import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { CModalPlanComponent } from './c-modal-plan.component';
import { CElementsMarqueursModule } from '../../c-autres/c-elements-marqueurs/c-elements-marqueurs.module';
import { CDrawingCanvasModule } from '../../c-autres/c-drawing-canvas/c-drawing-canvas.module';
import { IsNotEmptyStringModule } from 'src/app/pipes/is-not-empty-string/is-not-empty-string.module';
import { CSketchLegendeModule } from '../../c-autres/c-sketch-legende/c-sketch-legende.module';



@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    CElementsMarqueursModule,
    CDrawingCanvasModule,
    IsNotEmptyStringModule,
    CSketchLegendeModule,
  ],
  declarations: [
    CModalPlanComponent,
  ],
  exports: [
    CModalPlanComponent,
  ]
})
export class CModalPlanModule { }
